import { combineReducers } from 'redux';
import isUndefined from 'lodash/isUndefined.js';
import fromPairs from 'lodash/fromPairs.js';
import locationReducer from './location.js';
import composeReducers from '../state/@utils/reducers/composeReducers.ts';

const hasReducer = (route) => !isUndefined(route.reducer);
const hasGlobalReducer = (route) => !isUndefined(route.globalReducer);

export const createRootReducer = (history, routes) => {
    const globalReducers = routes.filter(hasGlobalReducer).map((route) => route.globalReducer);

    return composeReducers(
        combineReducers({
            location: locationReducer,
            // @TODO: move this somewhere else, perhaps to the root index.js of the `state` folder?
            ...fromPairs(routes.filter(hasReducer).map((route) => [route.route, route.reducer])),
        }),
        // add any global reducers at the top level since they need to know information from the global
        // state
        ...globalReducers,
    );
};
